import { newestFirstReplays } from "./matchups";
import {
  watchPlaylistLimit,
  watchStandingsTopN,
  type DivisionReplays,
  type WatchLeagueState,
} from "./records";

export function watchStateFromDivisions({
  leagueId,
  divisions: perDivision,
}: {
  readonly leagueId: string;
  readonly divisions: readonly DivisionReplays[];
}): WatchLeagueState {
  const playlist = newestFirstReplays(
    perDivision.flatMap((entry) => entry.replays),
  ).slice(0, watchPlaylistLimit);
  const featured =
    perDivision.find(
      (entry) => entry.division.id === playlist[0]?.matchup?.divisionId,
    ) ?? perDivision.find((entry) => entry.leaderboard.length > 0);
  return {
    leagueId,
    playlist,
    pool: featured?.pool ?? { replays: [], live: null },
    divisionLeaderboard: featured?.leaderboard ?? [],
    divisionId: featured?.division.id ?? null,
    standings: featured?.leaderboard.slice(0, watchStandingsTopN) ?? [],
    divisionName: featured?.division.name ?? null,
    divisionCount: perDivision.length,
    playerCount: perDivision.reduce(
      (total, entry) => total + entry.leaderboard.length,
      0,
    ),
    activeRound: featured?.activeRound ?? null,
    activeRoundProgress: featured?.activeRoundProgress ?? null,
    newestCompletedAt: featured?.newestCompletedAt ?? null,
    firstPlace: featured?.firstPlace ?? null,
  };
}
